
import axios from 'axios/index'
import { parseStringPromise } from 'xml2js';

const getServiceRoot = function (path) {
  let serviceRoot = process.env.NODE_ENV === 'development' ? 'https://beta.hamiltoncaster.com' : location.origin
  return `${serviceRoot}/DesktopModules/${path}/`
}
let rootPath = `${getServiceRoot('AcuitiSolutions')}CatalogDetail/API/List`

const getHeaders = function (svc, antiForgery) {
  let headers = {}
  headers["ModuleId"] = svc.moduleId
  headers["TabId"] = getTabId()
  if (antiForgery) {
    headers["RequestVerificationToken"] = antiForgery
  }
  return headers
}

/* global dnn */
const getTabId = function () {
  // Use window.dnn if available to satisfy eslint no-undef in environments where dnn is provided globally
  const d = typeof dnn !== 'undefined' ? dnn : (typeof window !== 'undefined' ? window.dnn : null)
  return d && typeof d.getVar === 'function' ? d.getVar("sf_tabId", -1) : -1
}

const addToCart = function (shoppingCart, svc, antiForgery) {
  let headers = getHeaders(svc, antiForgery)
  return axios.post(`${rootPath}/AddToCart`, shoppingCart, {headers})
    .then(res => res.data)
}

const CatalogDetailLink = `${rootPath}/GetPartDetails`

const getDetailsAPI = async function (partId, detailLink) {
  // let headers = getHeaders(svc, antiForgery)
  const encodedPartId = encodeURIComponent(String(partId || ''))
  const url = `${detailLink || CatalogDetailLink}?partId=${encodedPartId}`;
  const res = await axios.get(url, { responseType: 'text' });
  let data = res.data;
  // Try to detect XML (starts with < or <?xml)
  if (typeof data === 'string' && data.trim().startsWith('<')) {
    // Parse XML to JS object
    try {
      const parsed = await parseStringPromise(data, { explicitArray: false, mergeAttrs: true });
      // The root is likely PartDetailsDTO, flatten if needed
      data = parsed && parsed.PartDetailsDTO ? parsed.PartDetailsDTO : parsed;
    } catch (e) {
      // Parsing failed, return raw data
      console.warn('[getDetailsAPI] Failed to parse XML:', e);
      return data;
    }
  } else if (typeof data === 'string') {
    // JSON came back as a string because of responseType: 'text'
    try { data = JSON.parse(data); } catch (e) { /* leave as-is */ }
  }
  return normalizePartDetails(data);
}

// Normalize fields that may arrive as JSON booleans (true/false) or XML strings ("true"/"false"/"1"/"0").
// Keeps downstream v-if checks like `!productDetails.IsObsoletePart` correct regardless of source format.
const toBool = function (val) {
  if (typeof val === 'boolean') return val;
  if (val == null) return false;
  const s = String(val).trim().toLowerCase();
  return s === 'true' || s === '1' || s === 'yes';
}

const normalizePartDetails = function (data) {
  if (data && typeof data === 'object') {
    if ('IsObsoletePart' in data) data.IsObsoletePart = toBool(data.IsObsoletePart);
    if ('IsValidPart' in data) data.IsValidPart = toBool(data.IsValidPart);
  }
  return data;
}

const validateCADUserByEmail = function (email) {
  return axios.get(`${rootPath}/ValidateCADUserByEmail?email=${encodeURIComponent(email)}`)
    .then(res => res.data)
}

const validateCADUser = function (name, email) {
  // let headers = getHeaders(svc, antiForgery)
  return axios.get(`${rootPath}/ValidateCADUser?name=${name}&email=${email}`)
    .then(res => res.data)
}

const getIsValidCADUser = function () {
  return axios.get(`${rootPath}/IsValidCADUser`)
    .then(res => res.data)
}

const addCADUser = function (userData) {
  return axios.post(`${rootPath}/AddCADUser`, userData)
    .then(res => res.data)
}

const editCADUser = function (userData) {
  return axios.post(`${rootPath}/EditCADUser`, userData)
    .then(res => res.data)
}

const getProductConfiguratorAttributes = function (svc, antiForgery, configuratorParams) {
  let headers = getHeaders(svc, antiForgery)
  let baseUrl = `${location.origin}/API/AcuitiSolutions/ProductConfigurator/ProductConfigurator/GetProductConfiguratorResults`
  return axios.post(baseUrl, configuratorParams, {headers})
    .then(res => res)
}

const getVaultData = function (partID) {
  // Vault does not support '/' in Part IDs; normalize to '_'
  const normalized = encodeURIComponent(String(partID).replace(/\//g, '_'))
  return axios.get(`${rootPath}/GetVaultData?PartID=${normalized}`)
    .then(res => res.data)
}

const getOptionTypes = function (partID, svc, antiForgery) {
  const headers = svc ? getHeaders(svc, antiForgery) : {}
  const encodedPartID = encodeURIComponent(String(partID || ''))
  return axios.get(`${rootPath}/GetOptionTypes?BasePartID=${encodedPartID}`, { headers })
    .then(res => res.data)
    .catch(err => {
      throw err;
    })
}

const GetPartOptionCombos = function (partID, svc, antiForgery) {
  // Accept optional svc and antiForgery so callers can provide module headers when required by the API.
  const headers = svc ? getHeaders(svc, antiForgery) : {}
  const encodedPartID = encodeURIComponent(String(partID || ''))
  return axios.get(`${rootPath}/GetPartOptionCombos?BasePartID=${encodedPartID}`, { headers })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      throw err;
    })
}

// provide a camelCase alias for compatibility with components that import the lowercase name
const getPartOptionCombos = function (partID, svc, antiForgery) {
  return GetPartOptionCombos(partID, svc, antiForgery)
}

export {
  addToCart,
  addCADUser,
  getServiceRoot,
  editCADUser,
  getDetailsAPI,
  getIsValidCADUser,
  validateCADUser,
  validateCADUserByEmail, 
  getProductConfiguratorAttributes,
  getVaultData,
  GetPartOptionCombos,
  getPartOptionCombos,
  getOptionTypes
}
